import React from 'react';
import useModal from '../hooks/useModal';
import Modal from '../components/ModalPortal';

const ModalContext = React.createContext();
const { Provider } = ModalContext;

const ModalProvider = ({ children }) => {
  const { modal, closeModal, handleModal, modalTitle, modalContent, modalAction } = useModal();
  return (
    <Provider value={{ modal, closeModal, handleModal, modalTitle, modalContent, modalAction }}>
      <Modal />
      {children}
    </Provider>
  );
};

export { ModalContext, ModalProvider };
